(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["info-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

// ACCORDIONS
    const accordions = document.querySelectorAll(".info-accordion");

    accordions.forEach((accordion) => {
      accordion.addEventListener("click", function() {
        const openAccordion = document.querySelector(`.info-accordion.accordion-open`);

        if (! openAccordion) {
          accordion.classList.add("accordion-open");
          return;
        }

        if (openAccordion === accordion) {
          accordion.classList.remove("accordion-open");
          return;
        }

        openAccordion.classList.remove("accordion-open");
        accordion.classList.add("accordion-open");
      });
    });
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.variant-option').forEach(option => {
    option.addEventListener('click', function(event) {
      event.preventDefault();

      document.querySelector('input[name="id"]').value = this.dataset.variantId;

      document.querySelectorAll('.variant-option').forEach(option => {
        option.classList.remove('variant-selected');
      });

      this.classList.add('variant-selected');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
